import * as React from 'react';
import { MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_ADDGROUP } from '@editor/src/img/pageIndex';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';

function getSelectionService(): ISelectionService | undefined {
    const appService = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
    if (appService?.viewableServiceLayer?.selectionService) {
        return appService.viewableServiceLayer.selectionService;
    }
    return undefined;
}

export const config = {
    id: ActionType.ADDGROUP,
    imgSrc: TOOLBAR_ADDGROUP,
    content: i18n.t('组合'),
    tipPlacement: 'right',
    twdConfig: {
        handleFunction: () => {
            const ver5 = getSelectionService()?.selectedElements?.length;
            return {
                ver5,
                action: TDWActionType.GROUP,
            };
        },
    },
};

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        icon: <img src={config.imgSrc} alt={''}/>,
    },
    {
        name: MenuKey.ADD_GROUP,
        content: i18n.t<string>('组合'),
    },
];
